<template>
  <div class="sidebar">
    <div
      v-for="group in menuGroups"
      :key="group.title"
      class="sidebar__group"
    >
      <div class="sidebar__group__title">
        {{ group.title }}
      </div>
      <BliLists
        v-model="activeTab"
        class="sidebar__nav"
        separator="none"
      >
        <BliList
          v-for="item in group.items"
          :key="item.name"
          :data-testid="item.testId"
          class="sidebar__nav__item"
          :value="item.name"
          @click="navigate(item)"
        >
          <div class="sidebar__nav__item__content">
            <component
              :is="item.icon"
              class="sidebar__nav__item__icon"
            />
            <span>{{ item.label }}</span>
            <BliBadge
              v-if="item.badge"
              color="red"
              class="sidebar__nav__item__badge"
            >
              {{ item.badge }}
            </BliBadge>
          </div>
        </BliList>
      </BliLists>
    </div>
  </div>
</template>

<script src="./js/sidebar"></script>

<style scoped lang="scss">
.sidebar {
  width: 204px;
  min-height: calc(100vh - 64px);
  border-right: solid 1px $blu-color-neutral-border-med;
  flex-shrink: 0;
  padding: 16px;
  &__group {
    margin-bottom: 24px;
    &__title {
      font: $blu-text-body-2;
      color: $blu-color-neutral-text-disabled;
      padding: 16px;
    }
  }
  &__nav {
    display: flex;
    flex-direction: column;
  }
  &__nav__item {
    cursor: pointer;
    font: $blu-text-body-2;
    color: $blu-color-neutral-text-high;
    &__content {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    &__icon {
      flex-shrink: 0;
    }
  }
}
</style>
